import _ from 'lodash';
import config from '../config';
import partnerConfig from '../config/partners.json';

const { IS_SERVER } = config;

export default function getPartnerConfig(country, partnerId) {
  if (IS_SERVER) return;

  if (partnerId) {
    return _.find(partnerConfig[country], { id: partnerId }) || [];
  }

  // If no partnerId try matching partner with referrer instead.
  // This is needed until all partners start using partnerId.
  const referrer = document.referrer;

  const parts = referrer.replace(/https?:\/\//, '').split('/')[0].split('.');
  const domain = parts.length > 1 ? `${parts[parts.length - 2]}.${parts[parts.length - 1]}` : parts[0];

  const partner = _.filter(partnerConfig[country], (v) => {
    return _.includes(v.urls, domain);
  });

  return partner[0] || [];
}



// WEBPACK FOOTER //
// ./src/util/getPartnerConfig.js